import * as React from 'react';
import Container from '@mui/material/Container';

export default function RSVPFrame() {
  return (
    <Container sx={{
      height: "800px",
      px: {xs: 0},
    }}>
      <iframe src="https://www.aisleplanner.com/app/v2/our-wedding/courtandandrew/rsvp" 
        width="100%" 
        height="100%"
        style={{border: "0"}}
        loading="lazy" />
    </Container>
  );
}
